<template>
  <div>
      <pt-sub-title title="复购意向"></pt-sub-title>
      <table :class="$style['purchase-intention-detail']">
      <pt-form-list-item label="复购意向：" :required="true">
        <wt-radio v-model="formValue.repurchaseIntention" :radios="purchaseIntentionMode" data-vv-as="复购意向"
            name="shippingModes"  v-validate="'required'"></wt-radio>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { purchaseIntentionMode } from 'json/sign'
export default {
  name: 'purchase-intention',
  mixins: [formMixins],
  props: {
    notesDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      formValue: {},
      purchaseIntentionMode: purchaseIntentionMode
    }
  },
  watch: {
    notesDetail: {
      handler: function (val) {
        this.formValue = {
          ...val
        }
      }
    }
  }
}
</script>

<style module lang="less">
.purchase-intention-detail{
   padding: 0 20px;
}
</style>
